export default (input) => {
	if (!input) return true;
	const patternForOver8Digits = /^(\+?)(\d{8,})$/;
	const formattedNumber = input.replace(/\s+/g, "");

	if (formattedNumber.length < 8) {
		return false;
	} else if (formattedNumber.length >= 8) {
		return !!formattedNumber.match(patternForOver8Digits);
	}
};
